import { render } from "./HospitalCodeManagement.vue?vue&type=template&id=749ff229"
import script from "./HospitalCodeManagement.vue?vue&type=script&lang=js"
export * from "./HospitalCodeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__